import { createContext } from "react";

const NotificationContext = createContext({});

export default NotificationContext;
